type GoogleIdentityServicesWindow = Window & {
  google?: {
    accounts?: {
      id?: {
        disableAutoSelect?: () => void;
      };
    };
  };
};

export const disableGoogleIdentityAutoSelect = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  const disableAutoSelect = (window as GoogleIdentityServicesWindow).google?.accounts?.id
    ?.disableAutoSelect;
  if (typeof disableAutoSelect !== 'function') {
    return;
  }

  try {
    disableAutoSelect();
  } catch (error) {
    console.warn('[auth/googleIdentityServices] Failed to disable Google auto-select.', error);
  }
};
